'use client';
import { Modal } from '~components/Modals/Base';

import type { ModalProps } from '../../model/types';
import { Content } from './dynamicContent';
import { modal, Spacer } from './styles';

export const UserInfoModal = ({ open, onClose }: ModalProps) => (
	<Modal className={modal} open={open} locked={true} onClose={onClose}>
		<Spacer />
		<Content open={open} onClose={onClose} />
		<Spacer />
	</Modal>
);
